import React from 'react';
import { Alert, AlertTitle, Button, Stack } from '@mui/material';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('ErrorBoundary caught an error', error, info);
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <Alert severity="error" sx={{ my: 2 }}>
                    <AlertTitle>Something went wrong</AlertTitle>
                    <Stack spacing={1} alignItems="flex-start">
                        <span>This part of the page failed to render.</span>
                        <Button size="small" variant="outlined" onClick={() => window.location.reload()}>
                            Reload Page
                        </Button>
                    </Stack>
                </Alert>
            );
        }

        return this.props.children;
    }
}
